import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs';

import { AuthService } from '../../../infrastructure';
import { RequestLogout } from './login.actions';

@Injectable()
export class LogoutEffects {
  private actions$ = inject(Actions);
  private authService = inject(AuthService);

  requestLogout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RequestLogout),
        tap(({ reason, userInitiated }) => this.authService.logout(reason, userInitiated))
      ),
    { dispatch: false }
  );
}
